import React from 'react';
import { Wizard, WizardBanner } from '../../modules/unsw-wizard';
import Interview from '../../containers/Interview';
import PatientProvider from '../../containers/Providers/Patient';
import { Fade } from 'reactstrap';
import { RouteComponentProps, withRouter, generatePath } from 'react-router';
import OrganizationProvider from '../../containers/Providers/Organizations';
import { usePractitioner } from '../../contexts/practitioner';
import CarePlanProvider from '../../containers/Providers/CarePlan';

const InteviewLayout = (
  props: RouteComponentProps<{ organizationId: string; patientId: string }>,
) => {
  const { practitioner } = usePractitioner();
  if (!practitioner || !practitioner.id) return null;
  const path = generatePath(
    `/Organization/:organizationId/patient/:patientId`,
    props.match.params,
  );
  return (
    <OrganizationProvider organizationId={props.match.params.organizationId}>
      <PatientProvider patientId={props.match.params.patientId}>
        <CarePlanProvider patientId={props.match.params.patientId}>
          <Wizard onComplete={() => props.history.push(path)}>
            <WizardBanner />
            <Fade>
              <Interview />
            </Fade>
          </Wizard>
        </CarePlanProvider>
      </PatientProvider>
    </OrganizationProvider>
  );
};
export default withRouter(InteviewLayout);
